module.exports = __webpack_public_path__ + "static/media/dol-p.acc60ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResizableProduct/images/dol-p.png
// module id = 438
// module chunks = 0